<div class="iss-inclusive-buttons">
  <button
    *ngFor="let item of items"
    class="iss-inclusive-buttons__button control button"
    [class.is-primary.is-selected]="value.isSelected(identityFn(item))"
    (click)="onModelChange(item)"
    [disabled]="disabled"
  >
    <ng-container
      [ngTemplateOutlet]="templateRef || naive"
      [ngTemplateOutletContext]="{ $implicit: item }"
    />
  </button>
</div>

<ng-template #naive let-item>{{ textFn(item) }}</ng-template>
